import m from "../../es2015/lang/fo_FO";
window.am4lang_fo_FO = m;


//////////////////
// WEBPACK FOOTER
// ./lang/fo_FO.js
// module id = null
// module chunks = 